/* klubs-motion.js : mouvement et clavier. Les entrées au défilement ne concernent que ce qui arrive en défilant.
   Ce qui est déjà à l'écran au chargement s'affiche tout de suite, sans animation
   (m-scroll-trigger--cancel, classe de Minimog) ; ensuite seulement les animations sont
   permises (classe k-motion-ready, voir klubs-uniforme.css). Une seule fois par élément :
   animations.js cesse d'observer un élément dès qu'il est entré. */
(function () {
  function settle() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = Array.prototype.slice.call(document.getElementsByClassName("m-scroll-trigger"));
    // Toutes les mesures d'abord, puis toutes les écritures : alterner les deux forçait un recalcul de la
    // mise en page à chaque élément (tâche longue sur mobile, mesurée le 07/10 sur Cagnotte et Ouvrir).
    var visible = els.map(function (el) {
      var r = el.getBoundingClientRect();
      return r.top < vh && r.bottom > 0;
    });
    for (var i = 0; i < els.length; i++) if (visible[i]) els[i].classList.add("m-scroll-trigger--cancel");
    document.documentElement.classList.add("k-motion-ready");
    // Le reste (accès clavier) attend que le navigateur soit libre : rien ne presse avant la première touche.
    if ("requestIdleCallback" in window) window.requestIdleCallback(enhance, { timeout: 1500 });
    else setTimeout(enhance, 300);
  }
  function enhance() {
    // Carrousels qui défilent au doigt sur mobile : atteignables au clavier (WCAG 2.1.1).
    var scrollers = document.querySelectorAll(".m-mixed-layout--mobile-scroll, .ckv2-hero__meta");
    for (var j = 0; j < scrollers.length; j++) {
      var el = scrollers[j];
      if (el.scrollWidth > el.clientWidth + 1 && !el.hasAttribute("tabindex")) {
        el.setAttribute("tabindex", "0");
        el.setAttribute("role", "region");
        var h = el.closest(".shopify-section") && el.closest(".shopify-section").querySelector("h2, h3");
        el.setAttribute("aria-label", h ? h.textContent.trim() : "Carrousel");
      }
    }
    // Questions de FAQ (collapsible-tab de Minimog : un titre cliquable, pas un bouton) : la question
    // devient un bouton au clavier (Entrée ou Espace), avec son état ouvert ou fermé ; le titre reste un titre.
    var triggers = document.querySelectorAll("collapsible-tab [data-trigger]");
    for (var f = 0; f < triggers.length; f++) {
      var trig = triggers[f];
      // Déjà un vrai bouton (onglets « 3 étapes » de l'accueil) : rien à ajouter, sinon un élément
      // focalisable se retrouve dans le bouton (axe : nested-interactive).
      if (trig.tagName === "BUTTON" || trig.getAttribute("role") === "button") continue;
      var label = trig.querySelector("span") || trig;
      if (label.hasAttribute("tabindex")) continue;
      var tabEl = trig.closest("collapsible-tab");
      label.setAttribute("role", "button");
      label.setAttribute("tabindex", "0");
      label.setAttribute("aria-expanded", tabEl && tabEl.getAttribute("open") === "true" ? "true" : "false");
      label.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        this.click();
      });
      label.addEventListener("click", function () {
        var me = this;
        setTimeout(function () {
          var t = me.closest("collapsible-tab");
          me.setAttribute("aria-expanded", t && t.getAttribute("open") === "true" ? "true" : "false");
        }, 50);
      });
    }
    // Bouton du menu mobile (un span chez Minimog) : un vrai bouton au clavier.
    var burgers = document.querySelectorAll(".m-menu-button");
    for (var m = 0; m < burgers.length; m++) {
      var bt = burgers[m];
      if (bt.tagName === "BUTTON" || bt.hasAttribute("tabindex")) continue;
      bt.setAttribute("role", "button");
      bt.setAttribute("tabindex", "0");
      bt.setAttribute("aria-label", "Ouvrir le menu");
      bt.setAttribute("aria-expanded", "false");
      bt.addEventListener("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        // Minimog écoute le clic sur la boîte du hamburger, pas sur le span qui l'entoure.
        var box = this.querySelector(".m-hamburger-box") || this;
        box.click();
        this.setAttribute("aria-expanded", box.classList.contains("active") ? "true" : "false");
      });
    }
    // Échap ferme le menu mobile ouvert et rend le focus à son bouton.
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var box = document.querySelector(".m-hamburger-box.active");
      if (!box) return;
      box.click();
      var btn = box.closest(".m-menu-button");
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.focus();
      }
    });
    // Retour en haut : rendu avant l'en-tête, il était le premier arrêt de tabulation alors qu'il est
    // caché en haut de page. Il reste au doigt et à la souris ; au clavier, la touche Début fait de même.
    var toTop = document.getElementById("scroll-to-top-button");
    if (toTop) toTop.setAttribute("tabindex", "-1");
    // Onglets de la fiche produit (des div chez Minimog) : motif ARIA « tablist », atteignables au
    // clavier, Entrée ou Espace ouvre l'onglet, flèches gauche et droite passent d'un onglet à l'autre.
    var lists = document.querySelectorAll(".m-tabs__header-inner");
    for (var k = 0; k < lists.length; k++) {
      var list = lists[k];
      var tabs = list.querySelectorAll(".m-tab-header");
      if (!tabs.length || tabs[0].tagName === "BUTTON") continue;
      list.setAttribute("role", "tablist");
      for (var t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute("role", "tab");
        tabs[t].setAttribute("tabindex", "0");
        tabs[t].setAttribute("aria-selected", tabs[t].classList.contains("active") ? "true" : "false");
      }
      list.addEventListener("click", function (e) {
        var tab = e.target.closest(".m-tab-header");
        if (!tab) return;
        var all = this.querySelectorAll(".m-tab-header");
        for (var x = 0; x < all.length; x++) all[x].setAttribute("aria-selected", all[x] === tab ? "true" : "false");
      });
      list.addEventListener("keydown", function (e) {
        var tab = e.target.closest(".m-tab-header");
        if (!tab) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          tab.click();
        } else if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          var all = Array.prototype.slice.call(this.querySelectorAll(".m-tab-header"));
          var next = all[(all.indexOf(tab) + (e.key === "ArrowRight" ? 1 : all.length - 1)) % all.length];
          next.focus();
          next.click();
        }
      });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", settle);
  else settle();
})();
